import { PagesVoter } from './pages';
import { toId } from '../../../../helpers';

export class PagePublishVoter extends PagesVoter {
    supports(request) {
        return request.resource === 'page-publish';
    }

    /**
     * @param {AccessPermissionRequest} request
     * @returns {boolean}
     */
    vote(request) {
        const roleLimit = PagesVoter.getLimitByRole(request.role);
        const pages = request.get('website.pages', []);
        const subject = request.subject;

        let allowed = roleLimit;

        for (const page of pages) {
            if (subject && toId(subject) === toId(page)) {
                return true;
            }

            if (page.enabled) {
                allowed--;
            }

            if (allowed <= 0) {
                return false;
            }
        }
    }
}
